// extracted by mini-css-extract-plugin
export default {"footer-head":"footerhead_footer-head__LgR9h"};